import image1 from '../assets/images/ns_tunnel.png';
import image2 from '../assets/images/apex_tunnel.png';
import image3 from '../assets/images/ns_plus_vip.png';
import image4 from '../assets/images/rafi_fast_net.png';
import image5 from '../assets/images/mgtunnel.png';
import image6 from '../assets/images/mxultravpn.png';
import image7 from '../assets/images/pointboyvpn.png';
import image8 from '../assets/images/mgvipnet.png';
import image9 from '../assets/images/masalavpn.jpeg';



const productData = [
    {
      id: 1,
      name: "NS TUNNEL",
      image: image1,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 27,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://tinyurl.com/NsTunnel-Apk"
    },
    
    {
      id: 2,
      name: "APEX TUNNEL",
      image: image2,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 27,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://tinyurl.com/ApexTunnel-Apk"
    },
    {
      id: 3,
      name: "NS PLUS VIP",
      image: image3,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://tinyurl.com/NsPlusVip-Apk"
    },
    {
      id: 4,
      name: "Sumaiya Lite",
      image: image4,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://tinyurl.com/sumaiyalite-apk"
    },  {
      id: 5,
      name: "MG TUNNEL",
      image: image5,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://tinyurl.com/MgTunnel-Apk"
    },  {
      id: 6,
      name: "MX ULTRA VPN",
      image: image6,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://tinyurl.com/MxUltraVpn-apk"
    },  {
      id: 7,
      name: "POINT BOY VPN",
      image: image7,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://gitlab.com/fixbuildvw/ThreeProto/-/raw/main/app.fixbuild.PointBoyVpn-release.apk"
    },  {
      id: 8,
      name: "MG VIP NET",
      image: image8,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://gitlab.com/fixbuildvw/nstunnelvpn/-/raw/main/app.fixbuild.MGvipNet-release.apk"
    },  {
      id: 9,
      name: "MASALA VPN",
      image: image9,
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 24,
      reseller: "https://nstunnelvpn.xyz",
      appLink: "https://gitlab.com/fixbuildvw/nstunnelvpn/-/raw/main/MasalaVPN.apk"
    }
  ];
  export default productData;
